<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('transcript.transcriptList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="">{{$t('transcript.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.student.firstName')}}</label>
                                    <input type="text" class="search form-control" v-model="search.firstName"
                                        @keyup="searchStudents">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.student.lastName')}}</label>
                                    <input type="text" class="search form-control" v-model="search.lastName"
                                        @keyup="searchStudents">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.student.studentNumber')}}</label>
                                    <input type="text" class="search form-control" v-model="search.number"
                                        @keyup="searchStudents">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.student.transcriptName')}}</label>
                                    <input type="text" v-model="search.transcriptName" @keyup="searchStudents"
                                        class="search form-control">
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="detailedSearch">
                            <div class="col-12">
                                <hr>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('transcript.presetName')">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('transcript.transcriptList')}}</div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="students.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.student.studentName')}}</th>
                                    <th>{{$t('form.student.studentNumber')}}</th>
                                    <th>{{$t('form.student.program')}}</th>
                                    <th class="text-right">{{$t('transcript.transcript')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(student, index) in students" v-bind:key="index">
                                <tr>
                                    <td>{{student.Name}}</td>
                                    <td>{{student.StudentNumber}}</td>
                                    <td>{{student.Program}}</td>
                                    <!-- <td>{{student.FirstName }} {{student.LastName }}</td>
                                    <td>{{student.StudentNumber}}</td>
                                    <td>
                                        <span v-if="student.programs[0]">{{student.programs[0] | program}}</span>
                                    </td> -->
                                    <td class="text-right">
                                        <button class="btn btn-secondary btn-sm" @click="showTranscriptTerm(index)">
                                            <i class="far fa-file-alt"> {{$t('button.termTranscript')}}</i>
                                        </button>
                                        <button class="btn btn-secondary btn-sm" @click="showTranscriptYear(index)">
                                            <i class="far fa-file-alt"> {{$t('button.yearTranscript')}}</i>
                                        </button>
                                        <button class="btn btn-secondary btn-sm" @click="showTranscriptFull(index)">
                                            <i class="far fa-file-alt"> {{$t('button.fullTranscript')}}</i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>No record found.</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" @paginate="paginate()"
                        :offset="5">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                presetSelected: false,
                detailedSearch: false,

                pagination: {
                    current_page: 1
                },

                search: {},
                preset: {
                    name: '',
                    entity: 'transcript',
                    value: {}
                },

                presetList: [],
                students: [],
                currentPath:this.$route.path
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if (from.path && from.path.includes('/transcript/list') && to.path.includes('/transcript/list')) { // Call fn only when: route hasn't changed instead just query/params for the route has changed
                vm.isLoading = true;
            
            if ((to.path.includes('student/transcript/list') && !vm.permissions.viewStudentsTranscripts)){
                vm.$router.push('/');
                return;
            }
            if((to.path.includes('alumni/transcript/list') && !vm.permissions.viewAlumniTranscripts)){
                
                vm.$router.push('/');
                return;
            }
            if (localStorage.getItem('filter-transcript')) {
                vm.search = JSON.parse(localStorage.getItem('filter-transcript'));
            }

            vm.getStudents();
            vm.getPresets(); 
            vm.currentPath = to.path
            
            }
            })
        },
        mounted() {
            this.isLoading = true;
            
            if (!this.permissions.viewStudentsTranscripts) {
                this.$router.push('/');
                return;
            }

            if (localStorage.getItem('filter-transcript')) {
                this.search = JSON.parse(localStorage.getItem('filter-transcript'));
            }

            this.getStudents();
            this.getPresets();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-transcript', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {

            clearSearch() {
                this.search = {};
                this.searchStudents();
            },

            getStudents() {
                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                this.search.statusNot = 7;

                this.isLoading = true;
                var transcriptsToShow = '';
                if(this.$route.path.includes('alumni/')){
                    transcriptsToShow = 'alumni'
                }else if(this.$route.path.includes('student/')){
                    transcriptsToShow = 'student'
                }
                axios
                    .get('/api/transcripts?page=' + this.pagination.current_page+'&entity='+transcriptsToShow, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.isLoading = false;
                        this.students = response.data.data.data;
                        this.pagination = response.data.pagination;
                    })
                    .catch(error => {
                        this.isLoading = false;
                    });
            },

            paginate() {
                this.getStudents();
            },

            searchStudents() {
                this.pagination.current_page = 1;
                this.getStudents();
            },

            showTranscriptFull(index) {
                let id = this.students[index].ID;
                if(this.currentPath=='/student/transcript/list'){
                this.$router.push({
                    name: "TranscriptFullStudent",

                    params: {
                        id: id
                    }
                });
                }else if(this.currentPath=='/alumni/transcript/list'){
                this.$router.push({
                    name: "TranscriptFullAlumni",

                    params: {
                        id: id
                    }
                });
                }
                
            },

            showTranscriptTerm(index) {
                let id = this.students[index].ID;
                if(this.currentPath=='/student/transcript/list'){
                this.$router.push({
                    name: "TranscriptTermStudent",

                    params: {
                        id: id
                    }
                });
                }else if(this.currentPath=='/alumni/transcript/list'){
                this.$router.push({
                    name: "TranscriptTermAlumni",

                    params: {
                        id: id
                    }
                });
                }
                
            },

            showTranscriptYear(index) {
                let id = this.students[index].ID;

                 if(this.currentPath=='/student/transcript/list'){
                this.$router.push({
                    name: "TranscriptYearStudent",

                    params: {
                        id: id
                    }
                });
                }else if(this.currentPath=='/alumni/transcript/list'){
                this.$router.push({
                    name: "TranscriptYearAlumni",

                    params: {
                        id: id
                    }
                });
                }
            },

            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            loadPreset() {
                if (!this.preset) {
                    this.search = {};
                    this.preset = {
                        entity: 'transcript'
                    };
                    this.searchStudents();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchStudents();
            },

            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.search = {};
                                this.searchStudents();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
